import { render, staticRenderFns } from "./ProfileTitle.vue?vue&type=template&id=275371fc&scoped=true"
import script from "./ProfileTitle.vue?vue&type=script&lang=js"
export * from "./ProfileTitle.vue?vue&type=script&lang=js"
import style0 from "./ProfileTitle.vue?vue&type=style&index=0&id=275371fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275371fc",
  null
  
)

export default component.exports